export default __webpack_public_path__ + "static/media/Empty-profile.f17d0231.svg";